import styled from "styled-components";
import { colorTheme, textTheme } from "../../theme";
import { makeStyles } from "@material-ui/core/styles";
import { NavLink as RouterLink } from "react-router-dom";

export const tableStyles = {
  textOverflow: "ellipsis",
  whiteSpace: "nowrap" as any,
  overflow: "hidden",
  fontFamily: "Open Sans",
  fontWeight: "400" as any,
  fontSize: "13px",
  lineHeight: "20px",
  letterSpacing: "0.2px",
  color: "#737B7D",
};

export const headerStyle = {
  boxSizing: "border-box" as any,
  height: "56px",
  borderBottom: "1px solid rgba(226, 229, 230, 0.35)",
  fontFamily: "Open Sans",
  fontWeight: "600" as any,
  fontSize: "13px",
  lineHeight: "18px",
  letterSpacing: "0.2px",
  color: "#373F41",
};

export const getSearchFieldStyle = (tableWidth: string) => {
  return {
    width: tableWidth ? ((parseFloat(tableWidth) - 139) as any) : "",
    height: "42px",
    color: "#737B7D",
    fontFamily: "Open Sans",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "400" as any,
    lineHeight: "20px",
    letterSpacing: "0.2px",
    border: "1px solid #E2E5E6",
    boxSizing: "border-box" as any,
    borderRadius: "4px",
    paddingLeft: "18px",
  };
};

export const cellStyle = {
  boxSizing: "border-box",
  paddingTop: "0px",
  paddingBottom: "0px",
  height: "56px",
  borderBottom: "1px solid rgba(226, 229, 230, 0.35)",
  color: colorTheme.black,

  "&:hover": {
    cursor: "pointer",
  },
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TableHeader = styled.div<{ tableWidth: string }>`
  width: ${props => props.tableWidth};
  display: flex;
  justify-content: space-between;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  height: 42px;
`;

export const Title = styled.span`
  ${textTheme.h6};
  color: ${colorTheme.black};
`;

export const Count = styled.div`
  color: ${colorTheme.grayDark};
  background-color: ${colorTheme.grayLightest};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  width: 62px;
  height: 32px;
  border-radius: 40px;

  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.2px;
`;

export const ViewContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ViewIcon = styled.img`
  margin-left: 10px;

  &:hover {
    cursor: pointer;
  }
`;

export const Link = styled(RouterLink)`
  ${textTheme.button};
  background: ${colorTheme.newBlue};
  box-sizing: border-box;
  width: 120px;
  height: 42px;
  box-shadow: 0px 4px 10px rgba(16, 156, 241, 0.06);
  border-radius: 4px;
  border: none;
  color: ${colorTheme.white};
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TableContainer = styled.div<{
  tableWidth: string;
  viewType: string;
}>`
  margin-top: 22px;
  width: ${props => props.tableWidth};
  & > div {
    & > div {
      & > div:nth-child(2) {
        position: relative;
        border-radius: 4px;
        box-sizing: border-box;
        border: ${props =>
          props.viewType === "table"
            ? "1px solid rgba(226, 229, 230, 0.35)"
            : "none"};
        overflow-x: visible !important;
      }
    }
  }
`;

export const ToolbarWrapper = styled.div<{
  showFilters: any;
  sliderFilters: any;
  dropDownFilters: any;
  searchable: any;
  dataLength: any;
  editable: any;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${props => {
    if (props.searchable) {
      if (props.editable) {
        if (props.showFilters) {
          if (props.dropDownFilters && props.sliderFilters) {
            return "425px";
          } else if (props.dropDownFilters && !props.sliderFilters) {
            return "335px";
          } else if (!props.dropDownFilters && props.sliderFilters) {
            return "280px";
          }
        } else {
          return "105px";
        }
      } else if (!props.editable) {
        if (props.showFilters) {
          if (props.dropDownFilters && props.sliderFilters) {
            return "335px";
          } else if (props.dropDownFilters && !props.sliderFilters) {
            return "140px";
          } else if (!props.dropDownFilters && props.sliderFilters) {
            return "240px";
          }
        } else {
          return "38px";
        }
      }
    } else if (!props.searchable) {
      if (props.editable) {
        return "65px";
      } else {
        return "38px";
      }
    }
  }};
`;

export const Button = styled.button<{ theme: string }>`
  ${textTheme.button}
  background-color: ${props =>
    props.theme === "white"
      ? colorTheme.white + ";"
      : colorTheme.newBlue + ";"};
  color: ${props =>
    props.theme === "white"
      ? colorTheme.newBlue + ";"
      : colorTheme.white + ";"};
  height: 42px;
  width: 120px;
  border: 1px solid ${colorTheme.newBlue};
  box-sizing: border-box;
  box-shadow: 0px 4px 10px rgba(16, 156, 241, 0.06);
  border-radius: 4px;
  padding: 0px;
  &:hover {
    cursor: pointer;
  }
`;

export const FilterContainer = styled.tr<{
  tableWidth: string;
  showFilters: boolean;
  searchable: any;
  dropDownFilters: any;
  dataLength: number;
  editable: any;
  sliderFilters: any;
}>`
  visibility: ${props => (props.showFilters ? "visible" : "hidden")};
  width: ${props => props.tableWidth};
  position: absolute;
  z-index: 1;
  box-sizing: border-box;
  top: ${props => {
    if (props.searchable) {
      if (props.editable) {
        if (props.showFilters) {
          if (props.dropDownFilters && props.sliderFilters) {
            return "-390px";
          } else if (props.dropDownFilters && !props.sliderFilters) {
            return "335px";
          } else if (!props.dropDownFilters && props.sliderFilters) {
            return "-245px";
          }
        } else {
          return "65px";
        }
      } else if (!props.editable) {
        if (props.showFilters) {
          if (props.dropDownFilters && props.sliderFilters) {
            return "-300px";
          } else if (props.dropDownFilters && !props.sliderFilters) {
            return "-110px";
          } else if (!props.dropDownFilters && props.sliderFilters) {
            return "-205px";
          }
        }
      }
    } else if (!props.searchable) {
      if (props.editable) {
        return "65px";
      } else {
        return "38px";
      }
    }
  }};
`;

export const SliderSection = styled.th`
  display: flex;
  flex-flow: row wrap;
  // justify-content: space-between;

  margin: 0px -15px;
`;

export const DropDownSection = styled.th`
  display: flex;
  margin-bottom: 20px;
`;

export const GridItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
`;

export const GridItemImage = styled.img`
  border-radius: 10px;
  overflow: hidden;
  object-fit: cover;
  height: 248px;
  width: 308px;
`;

export const GridItemContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
`;

export const GridItemTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const TextName = styled.span`
  ${textTheme.h6}
  color: ${colorTheme.black};
`;

export const TextTitle = styled.span`
  ${textTheme.body2}
  color: ${colorTheme.black};
  margin-top: 5px;
`;

export const EllipsisContainer = styled.span`
  padding-top: 5px;
`;

export const RemoveContainer = styled.div`
  display: flex;
  alignitem: center;

  &:hover {
    cursor: pointer;
  }
`;

export const Remove = styled.span`
  margin-left: 5px;
  padding-top: 1px;
  ${textTheme.body2}
  color: ${colorTheme.black};
`;

export const AddMembersButton = styled.button<{
  disabled: boolean;
}>`
  position: absolute;
  right: 0px;
  top: -65px;
  ${textTheme.button}
  background-color: ${props =>
    props.disabled ? colorTheme.gray + ";" : colorTheme.newBlue + ";"};
  color: ${props =>
    props.disabled ? colorTheme.white + ";" : colorTheme.white + ";"};
  height: 42px;
  width: 185px;
  border: 1px solid
    ${props =>
      props.disabled ? colorTheme.gray + ";" : colorTheme.newBlue + ";"};
  box-sizing: border-box;
  border-radius: 4px;

  &:hover {
    cursor: pointer;
  }
`;

export const useStyles = makeStyles({
  paginationRoot: {
    overflowX: "hidden",
    marginLeft: "-3px",
  },
  paginationCaption: {
    display: "none",
  },
  paginationSelect: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #E7E7E7",
    boxSizing: "border-box",
    borderRadius: "4px",
    padding: "6px 40px 6px 10px !important",
    fontFamily: "Open Sans",
    fontSize: "13px",
    fontWeight: "400" as any,
    lineHeight: "20px",
    letterSpacing: "0.2px",
    color: "#737B7D",
  },
  paginationActions: {
    display: "none",
  },
  toolbarWrapper: {
    "& .MuiToolbar-root": {
      paddingLeft: 0,
      paddingRight: 0,
      minHeight: "42px",
    },
  },
  imageGridContainer: {
    "& .MuiTableBody-root": {
      display: "flex",
    },
  },
});
